import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

class CartDrawerUpsellComponent extends HTMLElement {
  connectedCallback() {
    this.quantityInput = this.querySelector('[data-upsell-quantity]');
    this.addButton = this.querySelector('[data-upsell-add]');
    this.errorElement = this.querySelector('[data-upsell-error]');

    this.querySelector('[data-upsell-quantity-decrease]')?.addEventListener('click', this.decreaseQuantity);
    this.querySelector('[data-upsell-quantity-increase]')?.addEventListener('click', this.increaseQuantity);
    this.quantityInput?.addEventListener('change', this.normalizeQuantity);
    this.quantityInput?.addEventListener('blur', this.normalizeQuantity);
    this.addButton?.addEventListener('click', this.addUpsell);
  }

  disconnectedCallback() {
    this.querySelector('[data-upsell-quantity-decrease]')?.removeEventListener('click', this.decreaseQuantity);
    this.querySelector('[data-upsell-quantity-increase]')?.removeEventListener('click', this.increaseQuantity);
    this.quantityInput?.removeEventListener('change', this.normalizeQuantity);
    this.quantityInput?.removeEventListener('blur', this.normalizeQuantity);
    this.addButton?.removeEventListener('click', this.addUpsell);
  }

  decreaseQuantity = () => {
    if (!this.quantityInput) return;
    this.quantityInput.stepDown();
    this.normalizeQuantity();
  };

  increaseQuantity = () => {
    if (!this.quantityInput) return;
    this.quantityInput.stepUp();
    this.normalizeQuantity();
  };

  normalizeQuantity = () => {
    if (!this.quantityInput) return;

    const min = Number(this.quantityInput.min) || 1;
    const max = this.quantityInput.max ? Number(this.quantityInput.max) : null;
    let value = Number(this.quantityInput.value) || min;

    if (value < min) value = min;
    if (max && value > max) value = max;

    this.quantityInput.value = String(value);
  };

  addUpsell = async () => {
    const variantId = Number(this.dataset.variantId);
    if (!variantId || !this.quantityInput || !this.addButton) return;

    this.normalizeQuantity();
    this.setError('');
    this.addButton.disabled = true;

    const quantity = Number(this.quantityInput.value) || 1;
    const sections = this.getCartSectionIds();
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity,
        },
      ],
      sections: sections.join(','),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
      const result = await response.json();

      if (!response.ok || result.status) {
        this.setError(result.description || result.message || 'Unable to add this item.');
        return;
      }

      document.dispatchEvent(
        new CartAddEvent(result, 'cart-drawer-upsell', {
          source: 'cart-drawer-upsell',
          itemCount: quantity,
          variantId: String(variantId),
          sections: result.sections,
        })
      );
    } catch (error) {
      console.error(error);
      this.setError('Unable to add this item.');
    } finally {
      this.addButton.disabled = false;
    }
  };

  getCartSectionIds() {
    const sectionIds = new Set();

    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.add(item.dataset.sectionId);
      }
    });

    return Array.from(sectionIds);
  }

  setError(message) {
    if (!this.errorElement) return;

    this.errorElement.textContent = message;
    this.errorElement.classList.toggle('hidden', !message);
  }
}

if (!customElements.get('cart-drawer-upsell-component')) {
  customElements.define('cart-drawer-upsell-component', CartDrawerUpsellComponent);
}
